import { Component, Inject, OnInit, Renderer2, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';
import { N_MODULE } from '../../../../config/config'; 

@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})

export class AddMasterProductComponent implements OnInit {
  public type: any[] = [
    {type: "Implants", value: "1"},
    {type: "Consumable", value: "0"}
  ];

  cat: any;
  searchTxt: null;
  isDropDownType = signal(false);
  public formData: any;
  public isEdited: boolean = false;
  public editOb: any;
  public nameTxt: any;
  public dragTxt: any;
  public file: any;
  public search: any;
  changedStoreType: any = {
    type: "", value: ""
  };
  public changedStoreName: string;
  public storeNames: any = [];

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if (data) {
      console.log("data", data)
      this.editOb = data;
      this.formData = this.editOb.item;
    }
  }

  ngOnInit(): void {
    if (this.formData) {
      console.log("formData", this.formData)
      this.changedStoreName = this.type.find(x => x.type == this.formData.type);
      this.onTypeChange(this.changedStoreName);
      this.nameTxt = this.formData.name;
      this.isEdited = true;
    }
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
        this.isDropDownType.set(false);
      }
    }); 
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onTypeChange(type: any): void {
    this.changedStoreType = type;
    this.isDropDownType.set(false);
  }

  onAdd() { 
    let data = {
      name: this.nameTxt,
      type: this.changedStoreType.value
    }
    if (this.isEdited) {
      this.masterdataService.masterEditBody('body_parts', this.formData.id, data).subscribe((res: any) => {
        this.onClose();
      });
    } else {
      this.masterdataService.masterAddItem('body_parts', data).subscribe((res: any) => {
        this.onClose();
      });
    }
  }
}
